import { render, staticRenderFns } from "./AboutPage.vue?vue&type=template&id=13688597&scoped=true&"
import script from "./AboutPage.vue?vue&type=script&lang=js&"
export * from "./AboutPage.vue?vue&type=script&lang=js&"
import style0 from "./AboutPage.vue?vue&type=style&index=0&id=13688597&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13688597",
  null
  
)

export default component.exports